import { z } from "zod";

export const loginSchema = z.object({
  email: z.string()
  .min(1,{ message: 'Email is required' })
  .email({ message: 'Invalid email address' }),

  password: z.string()
  	.min(1,{ message: 'Password is required' })
});

export const signupSchema = z.object({
  firstName: z.string().min(1,{message:'First name is required'}),
  lastName: z.string().min(1,{message:'First name is required'}),
  birthdate: z.string({message:'Date of birth required'}),
  gender: z.string(),
  email: z.string()
  .min(1,{ message: 'Email is required' })
  .email({ message: 'Invalid email address' }),

  password: z.string()
  .regex(/[A-Z]/, { message: 'Password must contain at least one uppercase letter' }) // Optional: require at least one uppercase letter
  .regex(/[a-z]/, { message: 'Password must contain at least one lowercase letter' }) // Optional: require at least one lowercase letter
  .regex(/[0-9]/, { message: 'Password must contain at least one number' }) // Optional: require at least one number
  .regex(/[\W_]/, { message: 'Password must contain at least one special character' }) // Optional: require at least one special character
  .min(8, { message: 'Password must be at least 8 characters long' }), // Adjust the length requirement as needed

  confirmPassword: z.string()
    .min(1, { message: 'Confirm your password' })
})
  .refine(data => data.password === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
});

export const forgotPasswordSchema = z.object({
  email: z.string()
  .min(1,{ message: 'Email is required' })
  .email({ message: 'Invalid email address' }),

  resetUrl: z.string().optional()
});

export const resetPasswordSchema = z.object({
  token: z.string().optional(),
  password: z.string()
  .regex(/[A-Z]/, { message: 'Password must contain at least one uppercase letter' }) // Optional: require at least one uppercase letter
  .regex(/[a-z]/, { message: 'Password must contain at least one lowercase letter' }) // Optional: require at least one lowercase letter
  .regex(/[0-9]/, { message: 'Password must contain at least one number' }) // Optional: require at least one number
  .regex(/[\W_]/, { message: 'Password must contain at least one special character' }) // Optional: require at least one special character
  .min(8, { message: 'Password must be at least 8 characters long' }), // Adjust the length requirement as needed

  confirmPassword: z.string()
    .min(1, { message: 'Confirm your password' })
})
  .refine(data => data.password === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  });